/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_2_TitleInputs */

const en_landing_how_2_title = /** @type {(inputs: Landing_How_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste one prompt`)
};

const id_landing_how_2_title = /** @type {(inputs: Landing_How_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempel satu prompt`)
};

/**
* | output |
* | --- |
* | "Paste one prompt" |
*
* @param {Landing_How_2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_how_2_title = /** @type {((inputs?: Landing_How_2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_how_2_title(inputs)
	return en_landing_how_2_title(inputs)
});